/**
 * Viewer（v-viewer）懒加载：进入详情/需要图片预览时再加载，避免首屏加载
 */
import Vue from 'vue'

let viewerPromise = null

export function loadViewer () {
  if (viewerPromise) return viewerPromise
  viewerPromise = import('v-viewer').then((viewerModule) => {
    const Viewer = viewerModule.default
    Vue.use(Viewer)
    Viewer.setDefaults({
      Options: {
        inline: true,
        button: false,
        navbar: false,
        title: false,
        toolbar: false,
        tooltip: false,
        movable: false,
        zoomable: false,
        rotatable: false,
        scalable: false,
        transition: false,
        fullscreen: true,
        keyboard: true,
        url: 'data-source'
      }
    })
    return import('viewerjs/dist/viewer.css')
  }).then(() => {})
  return viewerPromise
}



// WEBPACK FOOTER //
// ./src/assets/utils/lazyViewer.js